import {
  getActiveAppConfig,
  IS_BROWSER,
  isToEnableSSR,
  APPConfig,
  getAppConfig,
} from 'config/appConfig'
import { getB2CEndPoints } from './b2c'
import { getB2BEndPoints } from './b2b'
import { getLocaleCodeFromUrl } from 'src/utils'

function getCommonEndPoints(options) {
  const {
    studioCampaignId,
    studioDomain,
    studioEnv,
    apiDomainName,
    mySiteApiDomainName,
    orchestrationPathPrefix,
    catalogApiDomain,
    sonarIp,
    catalogCollectionId,
    oktaDomain,
    awsRecommendationDomain,
    smsVerifyDomain,
    phoneNumberUniquenessDomainUrl,
    emailLookupInfo,
    downConvertDomainName,
    mysiteRedesignApiDomain,
    cs_cloud_domain,
  } = getActiveAppConfig(options)
  const paymetricBaseUri = `https://${apiDomainName}/gps-tokenize`

  const activeEnvironment = APPConfig.getLocalEnv()

  // Cookie is not setting due to different domain
  // used separate domian only for CSR since store id, etc.., are same
  const orchestrationDomain =
    IS_BROWSER && document?.domain?.includes('.mynuskin.com')
      ? mySiteApiDomainName
      : apiDomainName

  //const API_ACCOUNT_COMMISSION = `https://${downConvertDomainName}/account-commission-status/v1/status`
  //const API_BASE_PATH = `https://${orchestrationDomain}/orchestrationservices/storefront`
  /* orchestrationPathPrefix - made configurable in defaultConfig.json
  Old value orchestrationPathPrefix : orchestrationservices/storefront
  New valule orchestrationPathPrefix : storefront */
  const API_BASE_PATH = `https://${orchestrationDomain}/${orchestrationPathPrefix}`

  // const catalogBasePath = `https://${
  //   catalogApiDomain || orchestrationDomain
  // }/orchestrationservices/storefront/catalogs`

  const catalogBasePath = `https://${
    catalogApiDomain || orchestrationDomain
  }/${orchestrationPathPrefix}/catalogs`

  // added <locale> and it will be dynamically replaced based on locale in apiUtils
  const nuskinFooter =
    'https://www.nuskin.com/apps/hello/services/marketfooter.<locale>.json'
  // const csLink =
  //   'https://cdn.contentstack.io/v3/content_types/homepage/entries/?locale=US-en&include_reference_content_type_uid=true&environment=public-test'
  const oktaClearUserSession = `${oktaDomain}/login/signout`

  let emailValidationDomain = `https://${orchestrationDomain}`
  const emailLookupInfoDomain = `https://${emailLookupInfo?.domain}`

  let sponsorLocale = 'US'
  if (IS_BROWSER) {
    let locale = getLocaleCodeFromUrl() || ''
    locale = locale?.toLowerCase()?.split('_')
    sponsorLocale = locale?.[1]?.toUpperCase()
    const domain = isToEnableSSR ? document.domain : activeEnvironment
    emailValidationDomain = `https://${domain}/${locale?.[1]}/${locale?.[0]}`
  }

  const API_URL_CONFIG = {
    basePath: `${API_BASE_PATH}`,
    reviewBasePath: `${API_BASE_PATH}/reviews`,
    accountsBasePath: `${API_BASE_PATH}/accounts`,
    catalogBasePath: `${catalogBasePath}`,
    customerBasePath: `${API_BASE_PATH}/customers`,
    cartBasePath: `${API_BASE_PATH}/carts/USER`,
    checkoutBasePath: `${API_BASE_PATH}/carts/checkoutservice/orders/USER`,
    subscriptionCartBasePath: `${API_BASE_PATH}/carts/SUBSCRIPTION`,
    subscriptionCreateBasePath: `${API_BASE_PATH}/carts/subscriptions`,
    subscriptionBasePath: `${API_BASE_PATH}/subscriptions`,
    subscriptionPreferenceBasePath: `${API_BASE_PATH}/subscriptions/preferences`,
    omsBasePath: `${API_BASE_PATH}/orders`,
    signUpBasePath: `${API_BASE_PATH}/customers`,
    tokenizeTaxBasePath: `${API_BASE_PATH}/customers/tokenize`,
    googleGeoBasePath: 'https://maps.googleapis.com/maps/api/geocode/json',
    loyaltyBasePath: `${API_BASE_PATH}/loyalty`,
    loyaltyPointsHistory: `${API_BASE_PATH}/loyalty/transactions`,
    inventoryPath: `${API_BASE_PATH}/inventory/binitems`,
    studioBasePath: `https://${studioDomain}/skavastream/studio/v3/skava/getPages/${studioCampaignId}/${studioEnv}`,
    tokenNuglobalBasePath: `${API_BASE_PATH}/carts/USER/payments/getTokenExAuthKey`,
    tokenNuglobalCvvPath: `${API_BASE_PATH}/carts/USER/payments/getTokenExAuthKey`,
    // local.skavacommerce is hardcoded
    // tokenBasePath: `${API_BASE_PATH}/carts/USER/paymnets/getTokenExAuthKey?origin=https://local.nuskin.com`,
    // tokenCvvPath: `${API_BASE_PATH}/carts/USER/paymnets/getTokenExAuthKey?origin=https%3A%2F%2Flocal.nuskin.com&token=`,
    paymetricIframeAccessTokenPath: `${paymetricBaseUri}/v1/iframe-access-token`,
    gpsIframeAccessTokenPath: `${API_BASE_PATH}/carts/USER/payments/gpsIframeAccessToken`,
    paymetricIframeTokenPath: `${paymetricBaseUri}/v1/iframe-token`,
    paymetricToken: `${API_BASE_PATH}/carts/USER/payments/paymetrictoken`,
    signupEmailIdValidation: `${API_BASE_PATH}/customers/checkUser`,
    nextGenAccountsBasePath: `${API_BASE_PATH}/accounts/nextgen`,
    signupSponsorIdValidation: `${API_BASE_PATH}/accounts/nextgen/sponsorer/${sponsorLocale}`,
    signupConsents: `${API_BASE_PATH}/customers/consents`,
    getUserConsents: `${API_BASE_PATH}/customers/userId/consents`,
    updateUserConsents: `${API_BASE_PATH}/customers/userconsents`,
    updateUserPrivacyConsents: `${API_BASE_PATH}/customers/userconsents`,
    userEmailNotification: `${API_BASE_PATH}/customers/emailnotification`,
    qualificationCustomer: `${API_BASE_PATH}/qualification/customerQualifications`,
    foreignOrderLimit: `${API_BASE_PATH}/carts/nuskin/restriction`,
    deleteSubscriptionFromCart: `${API_BASE_PATH}/carts/nuskin/USER`,
    solrBasePath: `http://${sonarIp}/solr/${catalogCollectionId}/select`,
    oktaSession: `${oktaDomain}/api/v1/sessions/me`,
    cartPatchPath: `${API_BASE_PATH}/carts`,
    awsRecommendationBasePath: `https://${awsRecommendationDomain}/v2/market`,
    postTaxIdDetails: `${API_BASE_PATH}/accounts/bulk/tax`,
    getTaxIdDetails: `${API_BASE_PATH}/accounts`,
    getCommissionRunProgressDetails: `${API_BASE_PATH}/accounts/check-commission-status/v1/status`,
    accountConversion: `${API_BASE_PATH}/accounts/v1`,
    getLegalTaxInputJson: `${API_BASE_PATH}/catalogs/assets`,
    postShippingMethod: `${API_BASE_PATH}/catalogs`,
    getAgreedTermStatus: `${API_BASE_PATH}/accounts/account-enrollment`,
    mysiteRedesignBaseUrl: `https://${mysiteRedesignApiDomain}/ns-share-api/v2/my-site`,
    personalOfferUrl: `https://${cs_cloud_domain}/ns-share-api/v1/connect/user`,
    personalOfferUrlV2: `https://${cs_cloud_domain}/ns-share-api/v2/product-offer/offers`,
    personalOfferAnalyticsUrl: `https://${cs_cloud_domain}/ns-share-api/v2/product-offer/analytics`,
    leadGenerationUrl: `https://${apiDomainName}/leads-api/v1`,
    DSSearchModelApi: `${API_BASE_PATH}/accounts/nextGen/getBrandAffiliateAccounts`,
  }

  const COMMON_END_POINTS = {
    postShippingMethod: {
      url: `${API_URL_CONFIG.postShippingMethod}/shipping`,
      method: 'POST',
    },
    agreedTermStatus: {
      url: `${API_URL_CONFIG.getAgreedTermStatus}/agreement-terms`,
      method: 'GET',
    },
    updateAgreedTermStatus: {
      url: `${API_URL_CONFIG.getAgreedTermStatus}/updateAgreement-terms`,
      method: 'PUT',
    },

    dcsvStatus: {
      url: `${API_URL_CONFIG.customerBasePath}/nextgen/dcsv/flagdetails`,
      method: 'GET',
    },
    updateDcsvStatus: {
      url: `${API_URL_CONFIG.customerBasePath}/nextgen/dcsv/updateflagdetails`,
      method: 'PUT',
    },
    commissionRunProgress: {
      url: `${API_URL_CONFIG.getCommissionRunProgressDetails}`,
      method: 'GET',
    },
    accountConversion: {
      url: `${API_URL_CONFIG.accountConversion}/do-conversion`,
      method: 'POST',
    },
    conversionStatus: {
      url: `${API_URL_CONFIG.accountConversion}/get-conversion-status`,
      method: 'GET',
    },
    mysiteCartPatch: {
      url: `${API_URL_CONFIG.cartPatchPath}`,
      method: 'PATCH',
    },
    sponsorIdValidation: {
      url: `${API_URL_CONFIG.signupSponsorIdValidation}`,
      method: 'GET',
    },
    signupEmailIdValidation: {
      url: `${API_URL_CONFIG.signupEmailIdValidation}`,
      method: 'POST',
    },
    tokenizeTax: {
      url: `${API_URL_CONFIG.tokenizeTaxBasePath}`,
      method: 'POST',
    },
    signupConsents: {
      url: `${API_URL_CONFIG.signupConsents}`,
      method: 'GET',
    },
    getUserConsents: {
      url: `${API_URL_CONFIG.getUserConsents}`,
      method: 'GET',
    },
    updateUserConsents: {
      url: `${API_URL_CONFIG.updateUserConsents}`,
      method: 'PUT',
    },
    updateUserPrivacyConsents: {
      url: `${API_URL_CONFIG.updateUserPrivacyConsents}`,
      method: 'PUT',
    },
    registerNextGen: {
      url: `${API_URL_CONFIG.nextGenAccountsBasePath}`,
      method: 'POST',
    },
    sponsorUpdateAccount: {
      url: `${API_URL_CONFIG.nextGenAccountsBasePath}`,
      method: 'PATCH',
    },
    topCategory: {
      url: `${API_URL_CONFIG.catalogBasePath}/categories/top`,
      method: 'GET',
    },
    DSSearch: {
      url: `${API_URL_CONFIG.DSSearchModelApi}`,
      method: 'POST',
    },
    getToken: {
      url: `${API_URL_CONFIG.tokenNuglobalBasePath}`,
      method: 'GET',
    },
    getTokenCvv: {
      url: `${API_URL_CONFIG.tokenNuglobalCvvPath}`,
      method: 'GET',
    },
    getPaymetricIframeAccessToken: {
      url: `${API_URL_CONFIG.paymetricIframeAccessTokenPath}`,
      method: 'POST',
    },
    getGpsIframeAccessToken: {
      url: `${API_URL_CONFIG.gpsIframeAccessTokenPath}`,
      method: 'POST',
    },
    getPaymetricToken: {
      url: `${API_URL_CONFIG.paymetricToken}`,
      method: 'GET',
    },
    getPaymetricIframeToken: {
      url: `${API_URL_CONFIG.paymetricIframeTokenPath}`,
      method: 'GET',
    },
    getCatalog: {
      url: `${API_URL_CONFIG.catalogBasePath}/categories`,
      method: 'GET',
    },
    getProducts: {
      url: `${API_URL_CONFIG.catalogBasePath}/products`,
      method: 'GET',
    },
    search: {
      url: `${API_URL_CONFIG.catalogBasePath}/search`,
      method: 'GET',
    },
    suggestions: {
      url: `${API_URL_CONFIG.catalogBasePath}/search/suggestions`,
      method: 'GET',
    },
    login: {
      url: `${API_URL_CONFIG.customerBasePath}/login`,
      method: 'POST',
    },
    deleteCustomer: {
      url: `${API_URL_CONFIG.customerBasePath}`,
      method: 'DELETE',
    },
    logout: {
      url: `${API_URL_CONFIG.customerBasePath}/logout`,
      method: 'DELETE',
    },
    getProfile: {
      url: `${API_URL_CONFIG.customerBasePath}`,
      method: 'GET',
    },
    updateProfile: {
      url: `${API_URL_CONFIG.customerBasePath}`,
      method: 'PATCH',
    },
    updatePassword: {
      url: `${API_URL_CONFIG.customerBasePath}/password`,
      method: 'PATCH',
    },
    register: {
      url: `${API_URL_CONFIG.customerBasePath}`,
      method: 'POST',
    },
    updateGuestCustomer: {
      url: `${API_URL_CONFIG.customerBasePath}/updateGuestCustomer`,
      method: 'PATCH',
    },
    viewCart: {
      url: `${API_URL_CONFIG.cartBasePath}`,
      method: 'GET',
    },
    viewCartForCheckout: {
      url: `${API_URL_CONFIG.cartBasePath}/checkout`,
      method: 'GET',
    },
    addToCart: {
      url: `${API_URL_CONFIG.cartBasePath}/items`,
      method: 'POST',
    },
    deleteCartItem: {
      url: `${API_URL_CONFIG.cartBasePath}/items`,
      method: 'DELETE',
    },
    removeSubscriptionCartItem: {
      url: `${API_URL_CONFIG.deleteSubscriptionFromCart}/items`,
      method: 'DELETE',
    },
    updateCartItem: {
      url: `${API_URL_CONFIG.cartBasePath}/items`,
      method: 'PATCH',
    },
    viewSubscriptionCart: {
      url: `${API_URL_CONFIG.subscriptionCartBasePath}`,
      method: 'GET',
    },
    getAccountTypes: {
      url: `${API_URL_CONFIG.accountsBasePath}/settings`,
      method: 'GET',
    },
    accounts: {
      url: `${API_URL_CONFIG.accountsBasePath}`,
      method: 'POST',
    },
    accountProfile: {
      url: `${API_URL_CONFIG.accountsBasePath}`,
      method: 'GET',
    },
    accountProfilePatch: {
      url: `${API_URL_CONFIG.accountsBasePath}`,
      method: 'PATCH',
    },
    // nextgenAccountUpgrade: {
    //   url: `${API_BASE_PATH}/accounts/nextgen`,
    //   method: 'PATCH',
    // },
    nextgenAccountUpgrade: {
      url: `${API_BASE_PATH}/accounts/nextgen`,
      method: 'PUT',
    },
    accountCheckSponsorid: {
      url: `${API_BASE_PATH}/accounts/nextgen/sponsorer`,
      method: 'GET',
    },
    nexGenAccountTypes: {
      url: `${API_BASE_PATH}/accounts/nextgen/accountType`,
      method: 'GET',
    },
    sendAssociateInviteLink: {
      url: `${API_BASE_PATH}/accounts/nextgen/associates`,
      method: 'POST',
    },
    patchAssociateInviteLink: {
      url: `${API_BASE_PATH}/accounts/nextgen/associates`,
      method: 'PATCH',
    },

    getAssociateInvitedetails: {
      url: `${API_BASE_PATH}/accounts/nextgen/associates`,
      method: 'GET',
    },

    addToSubscriptionCart: {
      url: `${API_URL_CONFIG.subscriptionCartBasePath}/items`,
      method: 'POST',
    },
    deleteSubscriptionCartItem: {
      url: `${API_URL_CONFIG.subscriptionCartBasePath}/items`,
      method: 'DELETE',
    },
    updateSubscriptionCartItem: {
      url: `${API_URL_CONFIG.subscriptionCartBasePath}/items`,
      method: 'PATCH',
    },
    updateSubscriptionCartAttributes: {
      url: `${API_URL_CONFIG.subscriptionCartBasePath}`,
      method: 'PATCH',
    },
    addPaymentToSubscription: {
      url: `${API_URL_CONFIG.subscriptionCartBasePath}/payments`,
      method: 'POST',
    },
    deletePaymentsFromSubscription: {
      url: `${API_URL_CONFIG.subscriptionCartBasePath}/payments`,
      method: 'DELETE',
    },
    getAllSubscriptions: {
      url: `${API_URL_CONFIG.subscriptionBasePath}`,
      method: 'GET',
    },
    getAllItemSubscriptions: {
      url: `${API_URL_CONFIG.subscriptionBasePath}`,
      method: 'GET',
    },
    getAllMultipleSubscriptions: {
      url: `${API_URL_CONFIG.subscriptionBasePath}/refresh`,
      method: 'POST',
    },
    getAllSubscriptionsPreference: {
      url: `${API_URL_CONFIG.subscriptionPreferenceBasePath}`,
      method: 'GET',
    },
    subscriptionPromoUpdate: {
      url: `${API_URL_CONFIG.subscriptionBasePath}`,
      method: 'PATCH',
    },
    updateSubscriptionsPreference: {
      url: `${API_URL_CONFIG.subscriptionPreferenceBasePath}`,
      method: 'PATCH',
    },
    postSubscriptionsPreference: {
      url: `${API_URL_CONFIG.subscriptionPreferenceBasePath}`,
      method: 'POST',
    },
    postSubscriptionItemLevelProcessing: {
      url: `${API_URL_CONFIG.subscriptionBasePath}`,
      method: 'PATCH',
    },
    getAllPvAssistItem: {
      url: `${API_URL_CONFIG.subscriptionPreferenceBasePath}/pvassist`,
      method: 'GET',
    },
    getSubscriptionById: {
      url: `${API_URL_CONFIG.subscriptionBasePath}`,
      method: 'GET',
    },
    updateSubscription: {
      url: `${API_URL_CONFIG.subscriptionBasePath}`,
      method: 'PATCH',
    },
    calculateSubscriptionDate: {
      url: `${API_URL_CONFIG.subscriptionCreateBasePath}/firstdeliverydate`,
      method: 'GET',
    },
    confirmSubscription: {
      url: `${API_URL_CONFIG.subscriptionCreateBasePath}/confirm`,
      method: 'POST',
    },
    geoCode: {
      url: `${API_URL_CONFIG.googleGeoBasePath}`,
      method: 'GET',
    },
    updateBagAttributes: {
      url: `${API_URL_CONFIG.cartBasePath}`,
      method: 'PATCH',
    },
    getPickUpLocations: {
      url: `${API_URL_CONFIG.basePath}/locations`,
      method: 'GET',
    },
    addPaymentToCart: {
      url: `${API_URL_CONFIG.cartBasePath}/payments`,
      method: 'POST',
    },
    addAlipayToCart: {
      url: `${API_URL_CONFIG.cartBasePath}/payments/alipayIntiate`,
      method: 'POST',
    },
    addKlarnaToCart: {
      url: `${API_URL_CONFIG.cartBasePath}/payments/klarnaIntiate`,
      method: 'POST',
    },
    getPayPalToken: {
      url: `${API_URL_CONFIG.cartBasePath}/payments/braintreeToken`,
      method: 'GET',
    },
    deletePaymentsFromCart: {
      url: `${API_URL_CONFIG.cartBasePath}/payments`,
      method: 'DELETE',
    },
    deletePaymentByIdFromCart: {
      url: `${API_URL_CONFIG.cartBasePath}/payments`,
      method: 'DELETE',
    },
    getBrainTreePaymentToken: {
      url: `${API_URL_CONFIG.cartBasePath}/payments/braintreeToken`,
      method: 'GET',
    },
    deleteLoyaltyRewardsFromCart: {
      url: `${API_URL_CONFIG.cartBasePath}/loyaltyRewards`,
      method: 'DELETE',
    },
    klarnaTransactionStatus: {
      url: `${API_URL_CONFIG.cartBasePath}/payments/klarnaStatus`,
      method: 'POST',
    },
    reviewOrder: {
      url: `${API_URL_CONFIG.checkoutBasePath}`,
      method: 'GET',
    },
    submitOrder: {
      url: `${API_URL_CONFIG.checkoutBasePath}`,
      method: 'POST',
    },
    getGlobalPaymentOptions: {
      url: `${API_URL_CONFIG.cartBasePath}/payments/globalPaymentOptions`,
      method: 'GET',
    },
    submitOrderForGlobalPayment: {
      url: `${API_URL_CONFIG.cartBasePath}/payments/gpsInitiate`,
      method: 'POST',
    },
    submitOrderForPaymetric3DS: {
      url: `${API_URL_CONFIG.cartBasePath}/payments/gps3dsInitiate`,
      method: 'POST',
    },
    addAccountPaymentForPaymetric3ds: {
      url: `${API_URL_CONFIG.customerBasePath}/payments`,
      method: 'POST',
    },
    gpsUpdate: {
      url: `${API_URL_CONFIG.cartBasePath}/payments/gpsUpdate`,
      method: 'POST',
    },
    getShippingMethodForDangerousGood: {
      url: `${API_URL_CONFIG.cartBasePath}/shipping`,
      method: 'GET',
    },
    getAllOrders: {
      url: `${API_URL_CONFIG.omsBasePath}`,
      method: 'GET',
    },

    suggestedOrders: {
      url: `${API_URL_CONFIG.omsBasePath}`,
      method: 'GET',
    },

    getOrderById: {
      url: `${API_URL_CONFIG.omsBasePath}`,
      method: 'GET',
    },
    returnlabel: {
      url: `${API_URL_CONFIG.omsBasePath}`,
      method: 'GET',
    },
    cancelItem: {
      url: `${API_URL_CONFIG.omsBasePath}`,
      method: 'PATCH',
    },
    returnItem: {
      url: `${API_URL_CONFIG.omsBasePath}`,
      method: 'POST',
    },
    updateOrder: {
      url: `${API_URL_CONFIG.omsBasePath}`,
      method: 'PATCH',
    },
    signUp: {
      url: `${API_URL_CONFIG.signUpBasePath}`,
      method: 'POST',
    },
    resetPassword: {
      url: `${API_URL_CONFIG.customerBasePath}/resetpassword`,
      method: 'POST',
    },
    validateResetPassword: {
      url: `${API_URL_CONFIG.customerBasePath}/resetpassword`,
      method: 'PATCH',
    },
    resetBySecurityQuestions: {
      url: `${API_URL_CONFIG.customerBasePath}/securityquestions/password`,
      method: 'POST',
    },
    addPromo: {
      url: `${API_URL_CONFIG.cartBasePath}/promos`,
      method: 'POST',
    },
    deletePromo: {
      url: `${API_URL_CONFIG.cartBasePath}/promos`,
      method: 'DELETE',
    },
    getStudioPage: {
      url: `${API_URL_CONFIG.studioBasePath}`,
      method: 'GET',
    },
    exportData: {
      url: `${API_URL_CONFIG.customerBasePath}/export`,
      method: 'POST',
    },
    notifyDirectSeller: {
      url: `${API_URL_CONFIG.leadGenerationUrl}/customer-intent`,
      method: 'POST',
    },
    verifyUserContactedForDSproduct: {
      url: `${API_URL_CONFIG.leadGenerationUrl}/customer`,
      method: 'GET',
    },
    loginAsCSR: {
      url: `${API_URL_CONFIG.customerBasePath}/sessions`,
      method: 'POST',
    },
    refreshSession: {
      url: `${API_URL_CONFIG.customerBasePath}/sessions/refresh`,
      method: 'POST',
    },
    getLoyalty: {
      url: `${API_URL_CONFIG.loyaltyBasePath}`,
      method: 'GET',
    },
    updateRewardsLoyaltyOptIn: {
      url: `${API_URL_CONFIG.customerBasePath}/opt`,
      method: 'POST',
    },
    getLoyaltyPoints: {
      url: `${API_URL_CONFIG.loyaltyBasePath}`,
      method: 'GET',
    },
    getLoyaltyPointHistory: {
      url: `${API_URL_CONFIG.loyaltyPointsHistory}`,
      method: 'GET',
    },
    getAllRatingsAndReviews: {
      url: `${API_URL_CONFIG.reviewBasePath}`,
      method: 'GET',
    },
    getReviewById: {
      url: `${API_URL_CONFIG.reviewBasePath}`,
      method: 'GET',
    },
    uploadImagesToReviews: {
      url: `${API_URL_CONFIG.reviewBasePath}`,
      method: 'POST',
    },
    createRatingAndReview: {
      url: `${API_URL_CONFIG.reviewBasePath}/createreview`,
      method: 'POST',
    },
    createReviewFeedback: {
      url: `${API_URL_CONFIG.reviewBasePath}/feedback`,
      method: 'POST',
    },
    getRatingsSummary: {
      url: `${API_URL_CONFIG.reviewBasePath}/ratingssummary`,
      method: 'GET',
    },
    getActiveAndLiveCount: {
      url: `${API_URL_CONFIG.subscriptionBasePath}/getactiveandlivecount`,
      method: 'GET',
    },
    updateCartToSubscription: {
      url: `${API_URL_CONFIG.subscriptionBasePath}/`,
      method: 'POST',
    },
    skipSubscription: {
      url: `${API_URL_CONFIG.subscriptionBasePath}`,
      method: 'PATCH',
    },
    addToSubscription: {
      url: `${API_URL_CONFIG.subscriptionBasePath}`,
      method: 'POST',
    },
    cancelAllSubscription: {
      url: `${API_URL_CONFIG.subscriptionBasePath}/user`,
      method: 'PATCH',
    },
    getStores: {
      url: `${API_BASE_PATH}/foundation/store`,
      method: 'GET',
    },
    getProductbyIdandPromotion: {
      url: `${API_URL_CONFIG.catalogBasePath}/products`,
      method: 'POST',
    },
    scanCardValidate: {
      url: `${API_URL_CONFIG.basePath}/scancard/validatescancard`,
      method: 'GET',
    },
    getscanCardDetails: {
      url: `${API_URL_CONFIG.basePath}/scancard`,
      method: 'GET',
    },
    getPromoCodeList: {
      url: `${API_URL_CONFIG.cartBasePath}/promocodes`,
      method: 'GET',
    },
    createscanCard: {
      url: `${API_URL_CONFIG.basePath}/scancard`,
      method: 'POST',
    },
    removeScanCardDetails: {
      url: `${API_URL_CONFIG.basePath}/scancard`,
      method: 'DELETE',
    },
    getInventory: {
      url: `${API_URL_CONFIG.inventoryPath}`,
      method: 'GET',
    },
    getOktaAuthorize: {
      url: `${API_URL_CONFIG.customerBasePath}/nextgen/okta/authorize`,
      method: 'GET',
    },
    emailNotification: {
      url: `${API_URL_CONFIG.userEmailNotification}`,
      method: 'POST',
    },
    qualificationUser: {
      url: `${API_URL_CONFIG.qualificationCustomer}`,
      method: 'GET',
    },
    foreignOrderLimit: {
      url: `${API_URL_CONFIG.foreignOrderLimit}`,
      method: 'POST',
    },
    // footerData: {
    //   url: nuskinFooter,
    //   method: 'GET',
    // },
    footerData: {
      // url: csLink,
      // URL is constructed in apiUtils-> fetchResponseFromAPI function
      method: 'GET',
    },
    studioData: {
      // url: csLink,
      // URL is constructed in apiUtils-> fetchResponseFromAPI function
      method: 'GET',
    },
    liveEventStudioData: {
      // url: csLink,
      // URL is constructed in apiUtils-> fetchResponseFromAPI function
      method: 'GET',
    },
    csPageEntry: {
      method: 'GET',
    },
    postalCodeLookup: {
      url: `${API_URL_CONFIG.customerBasePath}/plugin/postalcode`,
      method: 'POST',
    },
    postalCodeValidation: {
      url: `https://${getAppConfig().localeResourceFilesDomain}/assets/translations/es-AR/postal_code_lookup.json`,
      method: 'GET',
    },
    emailLookupMx: {
      url: `${emailValidationDomain}/validateEmail`,
      method: 'POST',
    },
    emailLookupInfo: {
      url: `${emailLookupInfoDomain}/email-tools/v1/emailInfo`,
      method: 'GET',
    },
    clearOktaUserSession: {
      url: oktaClearUserSession,
      method: 'GET',
    },
    getOktaSession: {
      url: API_URL_CONFIG.oktaSession,
      method: 'GET',
    },
    getAwsRecommendedProducts: {
      url: API_URL_CONFIG.awsRecommendationBasePath,
      method: 'GET',
    },
    checkPhoneNumberUniqueness: {
      url: phoneNumberUniquenessDomainUrl,
      method: 'POST',
    },
    sendPhoneVerificationCode: {
      url: `${smsVerifyDomain}/v1/mobile/verify`,
      method: 'POST',
    },
    checkPhoneVerificationCode: {
      url: `${smsVerifyDomain}/v1/mobile/verify/check`,
      method: 'POST',
    },
    postTaxIdData: {
      url: `${API_URL_CONFIG.postTaxIdDetails}`,
      method: 'POST',
    },
    getTaxIdData: {
      url: `${API_URL_CONFIG.getTaxIdDetails}`,
      method: 'GET',
    },
    getLegalTaxInputJson: {
      url: `${API_URL_CONFIG.getLegalTaxInputJson}`,
      method: 'GET',
    },
    pdpQuickShare: {
      url: `${API_URL_CONFIG.catalogBasePath}/productOffer`,
      method: 'POST',
    },
    mysiteSubDomainValidation: {
      url: `${API_URL_CONFIG.mysiteRedesignBaseUrl}/subdomain`,
      method: 'GET',
    },
    mysiteSponsorData: {
      url: `${API_URL_CONFIG.mysiteRedesignBaseUrl}`,
      method: 'GET',
    },
    sponsorLookup: {
      url: `https://${apiDomainName}/account-sponsorship/v1/sponsorLookup`,
      method: 'GET',
    },
    personalOfferData: {
      url: `${API_URL_CONFIG.personalOfferUrl}`,
      method: 'GET',
    },
    personalOfferDataV2: {
      url: `${API_URL_CONFIG.personalOfferUrlV2}`,
      method: 'GET',
    },
    productOfferAnalytics: {
      url: `${API_URL_CONFIG.personalOfferAnalyticsUrl}`,
      method: 'POST',
    },
    getBundlesAndKitsDetails: {
      url: `${API_URL_CONFIG.catalogBasePath}/search`,
      method: 'GET',
    },
    getMultiOrderInvoiceUrl: {
      url: `${API_URL_CONFIG.cartPatchPath}/invoiceorder/url`,
      method: 'GET',
    },
    createSubscriptionEMandate: {
      url: `${API_URL_CONFIG.subscriptionBasePath}`,
      method: 'POST',
    },
    updateSubscriptionEMandateStatus: {
      url: `${API_URL_CONFIG.subscriptionBasePath}`,
      method: 'PATCH',
    },
    deleteSubscriptionDashboardItem: {
      url: `${API_URL_CONFIG.subscriptionBasePath}`,
      method: 'DELETE',
    },
  }

  if (sonarIp && catalogCollectionId) {
    COMMON_END_POINTS['productFromSolr'] = {
      url: `${API_URL_CONFIG.solrBasePath}`,
      method: 'GET',
    }
  }

  return {
    ...COMMON_END_POINTS,
    ...getB2CEndPoints(API_BASE_PATH),
    ...getB2BEndPoints(API_BASE_PATH),
  }
}
export { getCommonEndPoints }
